import React from 'react';
import xtend from 'xtend';
import { Link } from 'react-router-dom'

import Loader from '../common/components/notifications/Loader';
import Campaign from './listings/Campaign';
import MetadataFilter from '../metadata/components/MetadataFilter';
import RestrictedComponent from '../lib/components/form/RestrictedComponent';
import schema from '../routes/permissions/schema';

class VastListing extends React.Component {
    constructor (props) {
        super(props)
        this.state = xtend(this.props.store(), {
            isTyping: false,
            term: ''
        });

        this.termChanged = this.termChanged.bind(this)
        this.handleTypingStarted = this.handleTypingStarted.bind(this)
    }

    componentWillMount () {
        var self = this;
        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });

        this.props.actions.get({});
    }

    componentWillUnmount () {
        this.removeListener();
    }

    termChanged (term) {
        this.setState({
            term: term.toLowerCase(),
            isTyping: false
        });
    }

    handleTypingStarted () {
        this.setState({
            isTyping: true
        });
    }

    render () {
        const { campaigns } = this.state;
        if (campaigns.isResolving) return <Loader message="Fetching"/>;

        var listing, foundMatch = false;
        if (this.state.isTyping) {
            listing = <Loader message='Filtering'/>;
        } else {
            listing = (campaigns.data && campaigns.data.length) ?
                campaigns.data.map(function (c, i) {
                    if (!this.state.term || c.name.toLowerCase().indexOf(this.state.term) > -1) {
                        foundMatch = true;
                        return <Campaign key={'campaign-' + i}
                            campaign={c}
                            actions={this.props.actions}
                            emitSnack={this.props.emitSnack}
                        />;
                    }
                }, this) : (<div className="alert alert-info">
                    <p>No Campaigns Available.</p>
                    <p><em><Link to="/manage/ads/edit">Create One Here &hellip;</Link></em></p>
            </div>);
        }

        return (<div>

            <div className="callout clearfix">
                <div className="col-md-6">
                    <MetadataFilter
                        termChanged={this.termChanged}
                        isTyping={this.handleTypingStarted}
                    />
                </div>
                <div className="col-md-6 text-right">
                    <RestrictedComponent permissionCheck={schema.MANAGE_ADS.CREATE}>
                        <Link to="/manage/ads/edit"
                            className="btn btn-primary"
                        >
                            <i className="fa fa-plus"/> Create New Campaign
                        </Link>
                    </RestrictedComponent>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    {listing}
                    {(!this.state.isTyping && this.state.term && !foundMatch) ? <div className="alert alert-warning">
                        No Matches Found.
                </div> : null}
                </div>
            </div>
        </div>);
    }
}

export default VastListing
